import { css } from 'aphrodite';
import { AiButton } from '../../components-v2/AiButton';
import { Button } from '../../components-v2/Button';
import { CameraIcon } from '../svgs/icons/CameraIcon';
import { styleSheet } from './styles';

export const ImageUploadButtons = ({
	hasImage,
	onClickFreeImage,
	onClickMedia,
	onGenerateClick,
}: {
	hasImage: boolean;
	onClickFreeImage: () => void;
	onClickMedia: () => void;
	onGenerateClick?: () => void;
}) => {
	return (
		<>
			{onGenerateClick && (
				<div className={css(styleSheet.generateButtonContainer)}>
					<AiButton title='New! Generate Image with AI' onClick={onGenerateClick} disabled={hasImage} size='default' />
				</div>
			)}
			<div className={css(styleSheet.addMediaContainer, styleSheet.contentContainers)}>
				<div>
					<Button
						type='button'
						variant='secondary'
						disabled={hasImage}
						onClick={onClickFreeImage}
						title={hasImage ? 'Only one image is supported at this time' : undefined}
						styles={[styleSheet.freeImage]}
					>
						<CameraIcon fillColor='currentColor' />
						<div> Free Images</div>
					</Button>
					<div className={css(styleSheet.sourceMention)}>Royalty free image library</div>
				</div>

				<div>
					<Button
						type='button'
						variant='link'
						disabled={hasImage}
						onClick={onClickMedia}
						title={hasImage ? 'Only one image is supported at this time' : undefined}
					>
						+ Upload Media
					</Button>
					<div className={css(styleSheet.sourceMention)}>Choose file from your computer</div>
				</div>
			</div>
		</>
	);
};
